<div oui-dialog-title>
  Fiche conseil obsolète
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content>
  <ng-container *ngIf="!isCreatingNewFiche; else loading">
    <div class="flex-vertical gap-24">
      <div class="flex-vertical" *ngIf="validityStatus === 'obsolete'">
        <div>Une mise à jour majeure a été publiée depuis la création de cette fiche conseil.</div>
        <div *ngIf="expirationDate">
          Cette fiche conseil sera conforme pour les dossiers signés
          <span class="bold">jusqu’au {{ expirationDate }} inclus.</span>
        </div>
      </div>

      <div class="flex-vertical" *ngIf="validityStatus === 'expired'">
        <div>Une mise à jour majeure a été publiée depuis la création de cette fiche conseil.</div>
        <div>Cette fiche conseil n’est plus conforme.</div>
      </div>
      <div class="flex-vertical gap-4">
        Pour garantir la conformité, vous pouvez créer une nouvelle fiche en cliquant sur le bouton ci-dessous.
      </div>
    </div>
  </ng-container>
</oui-dialog-content>
<ng-template #loading>
  <div class="flex-horizontal width-100pc flex-center justify-center">
    <oui-loading *ngIf="isCreatingNewFiche"></oui-loading>
  </div>
</ng-template>
<oui-dialog-actions>
  <oui-button type="contained" (click)="onCreateNewOne()">Créer une nouvelle fiche conseil</oui-button>
</oui-dialog-actions>
